import * as ACTIONS from "@iso/redux/settings/actionTypes";

const initialState = {
  translates: {
    list: [],
    total: 0,
  },
};

function translatesReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_SETTINGS_SUCCESS: {
      return {
        ...state,
        ...{ translates: payload },
      };
    }

    default:
      return state;
  }
}

export default translatesReducer;
